import { render, staticRenderFns } from "./acceptsHome.vue?vue&type=template&id=56778b25&scoped=true&"
import script from "./acceptsHome.vue?vue&type=script&lang=js&"
export * from "./acceptsHome.vue?vue&type=script&lang=js&"
import style0 from "./acceptsHome.vue?vue&type=style&index=0&id=56778b25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56778b25",
  null
  
)

export default component.exports